import React from 'react'
import { fetchLinkedOpportunityAnalysisCount } from '../services/analysisLinkedOpportunityService'

export function useLinkedOpportunityAnalysisCount(
  opportunityId: number | null,
  excludeAnalysisId: number | null,
  enabled: boolean,
) {
  const [count, setCount] = React.useState(0)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!enabled || opportunityId == null) {
      setCount(0)
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    fetchLinkedOpportunityAnalysisCount({
      opportunityId,
      excludeAnalysisId,
    })
      .then((next) => {
        if (!active) return
        setCount(next)
      })
      .catch((e: any) => {
        if (!active) return
        setCount(0)
        setError(e?.message || 'Falha ao verificar analises existentes')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, excludeAnalysisId, opportunityId])

  return { count, loading, error }
}
